import _ from 'underscore';
import { booleanField } from './boolean';
import { enumField } from './enum';
import { integerField } from './integer';
import { numberField } from './number';
import { stringField } from './string';

const mapping = {
  boolean: booleanField,
  enum: enumField,
  integer: integerField,
  number: numberField,
  string: stringField,
};

/**
 * get field define base on format or type
 * @private
 * @param {Object} attrs - property define
 * @returns {Object} - field define
 */
export function typeField(attrs = {}) {
  let key;

  if (attrs.format) {
    key = attrs.format;
  } else {
    key = _.isEmpty(attrs.enum) ? attrs.type : 'enum';
  }

  const field = mapping[key];

  if (_.isFunction(field)) {
    return field(attrs);
  }

  return field;
}
